export enum ChangeLogsHistoryType {
    agent = 'agent',
    registrant = 'registrant',
}
